import { render, staticRenderFns } from "./VentaMostrador.view.vue?vue&type=template&id=ef11bb78&"
import script from "./VentaMostrador.view.vue?vue&type=script&lang=js&"
export * from "./VentaMostrador.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports